export const GET_REMARK_THRU_REFID = "V1_GET_REMARK_THRU_REFID";
export const CREATE_REMARK = "V1_CREATE_REMARK";
export const UPDATE_REMARK = "V1_UPDATE_REMARK";
export const DELETE_REMARK = "V1_DELETE_REMARK";
export const CLOSE_REMARK = "V1_CLOSE_REMARK";